import { render, staticRenderFns } from "./LayoutContentCenturion.vue?vue&type=template&id=67cde6ef&scoped=true&"
import script from "./LayoutContentCenturion.vue?vue&type=script&lang=js&"
export * from "./LayoutContentCenturion.vue?vue&type=script&lang=js&"
import style0 from "./LayoutContentCenturion.vue?vue&type=style&index=0&id=67cde6ef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67cde6ef",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VFooter } from 'vuetify/lib/components/VFooter';
import { VMain } from 'vuetify/lib/components/VMain';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
installComponents(component, {VApp,VAppBar,VFooter,VMain,VOverlay})
